// extracted by mini-css-extract-plugin
export var boldText = "_7q-4";
export var checkboxContainer = "_7q-6";
export var closeIcon = "_7q-i";
export var container = "_7q-0";
export var drawer = "_7q-8";
export var drawerContent = "_7q-9";
export var extraSmallText = "_7q-5";
export var fulfillmentGroupTable = "_7q-e";
export var largeText = "_7q-3";
export var loadingSpinnerContainer = "_7q-j";
export var mediumText = "_7q-2";
export var narrow = "_7q-f";
export var notificationLink = "_7q-l";
export var packageCheckIconContainer = "_7q-7";
export var slideoutHeaderActions = "_7q-g";
export var slideoutHeaderActionsShifted = "_7q-h";
export var slideoutHeaderContainer = "_7q-a";
export var slideoutModal = "_7q-c";
export var stickyHeaderWrapper = "_7q-b";
export var table = "_7q-k";
export var tableContainer = "_7q-d";
export var tertiaryText = "_7q-1";